import React from 'react';
import Icon from '../../../components/AppIcon';

const DynamicProgressIndicator = ({ currentStep, totalSteps, academicLevel }) => {
  const getStepLabels = () => {
    const baseSteps = [
      { number: 1, label: 'Niveau Académique', icon: 'Compass' },
      { number: 2, label: 'Informations Personnelles', icon: 'User' }
    ];

    let finalStep = { number: 3, label: 'Finalisation', icon: 'Check' };

    if (academicLevel === 'middle-school') {
      finalStep = { number: 3, label: 'Découverte', icon: 'Sparkles' };
    } else if (academicLevel === 'high-school') {
      finalStep = { number: 3, label: 'Préférences', icon: 'Target' };
    } else if (academicLevel === 'university') {
      finalStep = { number: 3, label: 'Parcours Académique', icon: 'Award' };
    }

    return [...baseSteps, finalStep];
  };

  const steps = getStepLabels();

  const getStepStatus = (stepNumber) => {
    if (stepNumber < currentStep) return 'completed';
    if (stepNumber === currentStep) return 'current';
    return 'upcoming';
  };

  const getColorClasses = () => {
    if (academicLevel === 'middle-school') {
      return {
        completed: 'bg-green-500 border-green-500',
        current: 'bg-green-500 border-green-500',
        upcoming: 'bg-gray-200 border-gray-300',
        line: 'bg-green-500'
      };
    } else if (academicLevel === 'high-school') {
      return {
        completed: 'bg-blue-500 border-blue-500',
        current: 'bg-blue-500 border-blue-500',
        upcoming: 'bg-gray-200 border-gray-300',
        line: 'bg-blue-500'
      };
    } else if (academicLevel === 'university') {
      return {
        completed: 'bg-purple-500 border-purple-500',
        current: 'bg-purple-500 border-purple-500',
        upcoming: 'bg-gray-200 border-gray-300',
        line: 'bg-purple-500'
      };
    }
    return {
      completed: 'bg-blue-500 border-blue-500',
      current: 'bg-blue-500 border-blue-500',
      upcoming: 'bg-gray-200 border-gray-300',
      line: 'bg-blue-500'
    };
  };

  const colors = getColorClasses();

  return (
    <div className="w-full max-w-3xl mx-auto">
      <div className="relative">
        {/* Progress Line */}
        <div className="absolute top-6 left-0 right-0 h-1 bg-gray-200">
          <div
            className={`h-full ${colors?.line} transition-all duration-500`}
            style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
          />
        </div>

        {/* Steps */}
        <div className="relative flex justify-between">
          {steps?.map((step) => {
            const status = getStepStatus(step?.number);
            const isCompleted = status === 'completed';
            const isCurrent = status === 'current';

            return (
              <div key={step?.number} className="flex flex-col items-center">
                <div
                  className={`w-12 h-12 rounded-full border-4 flex items-center justify-center transition-all duration-300 ${
                    isCompleted || isCurrent ? colors?.current : colors?.upcoming
                  } ${isCurrent ? 'scale-110 shadow-lg' : ''}`}
                >
                  {isCompleted ? (
                    <Icon name="Check" size={24} color="#FFFFFF" />
                  ) : (
                    <Icon
                      name={step?.icon}
                      size={20}
                      color={isCurrent ? '#FFFFFF' : '#9CA3AF'}
                    />
                  )}
                </div>
                <div className="mt-3 text-center">
                  <p
                    className={`text-xs md:text-sm font-medium ${
                      isCompleted || isCurrent ? 'text-gray-900' : 'text-gray-500'
                    }`}
                  >
                    {step?.label}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Progress Percentage */}
      <div className="mt-6 text-center">
        <p className="text-sm text-gray-600">
          Progression: <span className="font-semibold">{Math.round((currentStep / totalSteps) * 100)}%</span>
        </p>
      </div>
    </div>
  );
};

export default DynamicProgressIndicator;